import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getServices } from 'modules/settings/api';

export const useQueryServices = () => {
  const {
    data: services,
    isLoading: isLoadingServices,
    isError: isErrorServices,
  } = useQuery([QUERY_KEYS.SETTINGS_SERVICES], getServices, {
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });

  return { services, isLoadingServices, isErrorServices };
};
